<template>
  <a-range-picker
    class="range-picker-facade"
    v-model:value="model"
    :disabled="disabled"
    :disabled-date="disabledDate"
    format="DD.MM.YYYY"
    :locale="locale"
    :placeholder="placeholder"
    @calendar-change="(dates, dateStrings, info) => $emit('calendar-change', dates, dateStrings, info)"
    @open-change="(status) => $emit('open-change', status)"
  />
</template>

<script setup>
  /**
   * Компонент-фасад для компонента <a-range-picker/> из библиотеки ant-design-vue.
   * Его нужно использовать в коде компонентов вместо <a-range-picker/>.
   */
  import { defineModel } from 'vue';
  import locale from 'ant-design-vue/es/date-picker/locale/ru_RU';

  const model = defineModel();

  defineProps({
    // Determine whether the RangePicker is disabled
    disabled: {
      type: Boolean,
      default: false,
    },

    // Specify the date that cannot be selected
    disabledDate: {
      type: Function,
      default: () => false,
    },

    // The placeholder of date input
    placeholder: Array,
  });

  defineEmits(['calendar-change', 'open-change']);
</script>

<style lang="scss" scoped>

</style>